import React, { useState } from 'react';
import { Prompt } from 'react-router-dom';
import usePreventLeave from 'react-hook-use-prevent-leave';
import Button from '@mui/material/Button';

function PageShouldBlockWhenTryToLeave(): React.ReactElement {
  /* State */
  const [blockPage, setBlockPage] = useState<boolean>(true);

  /* Function */
  function togglePageBlock(): void {
    setBlockPage((prev) => !prev);
  }

  /* Hook */
  usePreventLeave(blockPage);

  /* Main */
  return (
    <React.Fragment>
      <Prompt when={blockPage} message={'Confirm to leave this page?'} />
      <h2>Block demo</h2>
      <div>This page is {!blockPage && 'NOT'} block now.</div>
      <Button onClick={togglePageBlock} variant="contained" disableElevation>
        Click to toggle block or not.
      </Button>
    </React.Fragment>
  );
}

export default PageShouldBlockWhenTryToLeave;
